import React, { useState, forwardRef } from 'react';
import './ContactSection.css';

const ContactSection = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    challenges: ['', ''],
    talkAbout: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('challenge')) {
      const index = parseInt(name.slice(-1)) - 1;
      const newChallenges = [...formData.challenges];
      newChallenges[index] = value;
      setFormData({ ...formData, challenges: newChallenges });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        throw new Error('Failed to send email');
      }
  
      // Clear form after successful submission
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        challenges: ['', ''],
        talkAbout: ''
      });
  
      // Show success message to user
      alert('Your message has been sent successfully!');
  
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Failed to send message. Please try again.');
    }
  };

  return (
    <section id="contact" className="contact-section" ref={ref}>
      <div className="container">
        <h2 className="section-title">Let's Connect</h2>
        <p className="section-description">
          Share your challenges with us and let's discuss how we can help transform your business with AI
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Company"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone"
              />
            </div>
          </div>
          
          <div className="challenges-section">
            <div className="form-group">
              <input
                type="text"
                name="challenge1"
                value={formData.challenges[0]}
                onChange={handleChange}
                placeholder="Challenge 1"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="challenge2"
                value={formData.challenges[1]}
                onChange={handleChange}
                placeholder="Challenge 2"
              />
            </div>
          </div>
          
          <div className="form-group">
            <textarea
              name="talkAbout"
              value={formData.talkAbout}
              onChange={handleChange}
              placeholder="What would you like to talk about?"
            />
          </div>
          
          <button type="submit" className="submit-button">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
});

export default ContactSection;